export const SET_CHAT_NEW_MESSAGE = "SET_CHAT_NEW_MESSAGE";
